import { styled } from "@mui/material/styles";

// ── Backdrop / scrim ──────────────────────────────────────────────────────────

export const OrientationBackdrop = styled("div")({
  position: "fixed",
  inset: 0,
  background: "rgba(2,0,40,0.82)",
  backdropFilter: "blur(10px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1400,
  padding: 24,
  animation: "mp-fade-in 200ms ease-out",
});

// ── Modal panel ───────────────────────────────────────────────────────────────

export const OrientationPanel = styled("div")({
  position: "relative",
  width: "min(860px, 92vw)",
  background: "linear-gradient(180deg, #0F0B3E 0%, #07052A 100%)",
  border: "1px solid rgba(150,46,255,0.25)",
  borderRadius: 20,
  overflow: "hidden",
  boxShadow: "0 24px 80px rgba(0,0,0,0.6), 0 0 0 1px rgba(150,46,255,0.08)",
  animation: "mp-slide-up 350ms cubic-bezier(0.16,1,0.3,1)",
});

// ── Top bar ───────────────────────────────────────────────────────────────────

export const OrientationTopBar = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 12,
  padding: "16px 20px",
  borderBottom: "1px solid rgba(255,255,255,0.07)",
});

export const OrientationBrandMark = styled("div")({
  width: 32,
  height: 32,
  borderRadius: 8,
  background: "linear-gradient(135deg, #01ECFF, #962EFF)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 16,
  fontWeight: 700,
  color: "#030039",
  fontFamily: "Poppins, sans-serif",
  flexShrink: 0,
});

export const OrientationTopBarTitle = styled("span")({
  flex: 1,
  fontSize: 13,
  fontWeight: 600,
  color: "#D1C7FF",
  fontFamily: "Poppins, sans-serif",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const OrientationStepCount = styled("span")({
  fontSize: 12,
  color: "#A87EFF",
  fontFamily: "Poppins, sans-serif",
  flexShrink: 0,
});

export const OrientationCloseBtn = styled("button")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 32,
  height: 32,
  borderRadius: "50%",
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(255,255,255,0.12)",
  color: "#A87EFF",
  cursor: "pointer",
  padding: 0,
  flexShrink: 0,
  transition: "background 150ms, color 150ms",
  "&:hover": {
    background: "rgba(255,255,255,0.12)",
    color: "#FEFEFE",
  },
});

// ── Progress segments ─────────────────────────────────────────────────────────

export const OrientationProgressRow = styled("div")({
  display: "flex",
  gap: 4,
  padding: "12px 20px 0",
  marginBottom: "12px"
});

export const OrientationProgressSegment = styled("button")(({ $done, $active }) => ({
  flex: 1,
  height: 4,
  borderRadius: 999,
  background: $done
    ? "linear-gradient(90deg, #01ECFF, #962EFF)"
    : $active
      ? "rgba(255,255,255,0.15)"
      : "rgba(255,255,255,0.08)",
  border: "none",
  cursor: "pointer",
  padding: 0,
  position: "relative",
  overflow: "hidden",
  transition: "background 200ms",
}));

export const OrientationProgressFill = styled("span")({
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  width: "100%",
  background: "linear-gradient(90deg, #01ECFF, #962EFF)",
  borderRadius: 999,
  transformOrigin: "left center",
  animation: "mp-progress-fill 0.5s ease-out",
  "@keyframes mp-progress-fill": {
    from: { transform: "scaleX(0)" },
    to: { transform: "scaleX(1)" },
  },
});

// ── Video stage ───────────────────────────────────────────────────────────────

export const OrientationVideoStage = styled("div")(({ $a, $b }) => ({
  position: "relative",
  aspectRatio: "16 / 9",
  background: `radial-gradient(120% 80% at 30% 20%, ${$a}55 0%, transparent 60%),
               radial-gradient(120% 80% at 80% 90%, ${$b}66 0%, transparent 60%),
               linear-gradient(135deg, ${$a}33 0%, ${$b}55 100%)`,
  overflow: "hidden",
}));

export const OrientationVideoEl = styled("video")({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
});

// ── Body ──────────────────────────────────────────────────────────────────────

export const OrientationBody = styled("div")({
  padding: "24px 28px 20px",
  display: "flex",
  flexDirection: "column",
  gap: 8,
});

export const OrientationEyebrow = styled("span")({
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "#01ECFF",
  fontFamily: "Poppins, sans-serif",
});

export const OrientationTitle = styled("h2")({
  fontSize: 24,
  fontWeight: 600,
  color: "#FEFEFE",
  margin: "4px 0 0",
  fontFamily: "Poppins, sans-serif",
  lineHeight: 1.25,
});

export const OrientationBlurb = styled("p")({
  fontSize: 14,
  color: "#D1C7FF",
  margin: "8px 0 0",
  lineHeight: 1.6,
  fontFamily: "Poppins, sans-serif",
});

// ── Footer ────────────────────────────────────────────────────────────────────

export const OrientationFooter = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: 10,
  padding: "16px 28px 24px",
  borderTop: "1px solid rgba(255,255,255,0.07)",
});

export const OrientationFooterSpacer = styled("div")({
  flex: 1,
});
